import { render, staticRenderFns } from "./OptionIncludedIcon.vue?vue&type=template&id=234b02f6&scoped=true"
import script from "./OptionIncludedIcon.vue?vue&type=script&lang=js"
export * from "./OptionIncludedIcon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "234b02f6",
  null
  
)

export default component.exports